import Block from '../block'

export default class ShoppingcartPopupProduct extends Block {
	static title = 'shoppingcart-popup-product'

	init() {
		this.inputElement = this.element.querySelector('[name="count"]')
		if (this.inputElement) {
			this.inputElement.addEventListener('change', () =>
				this.editCount(this.inputElement.value)
			)
		}

		this.removeButton = this.getElement('delete')
		if (this.removeButton) {
			this.removeButton.addEventListener('click', () => this.editCount(0))
		}

		this.productCount = this.getElement('count')
	}

	editCount(count) {
		const payload = new FormData()
		payload.append('update', true)
		payload.append('product_id', this.element.getAttribute('data-product-id'))
		payload.append('count', count)
		payload.append('ajax', true)

		fetch('/shoppingcart', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then(response => response.json())
			.then(json => {
				if (json.error) {
					return
				}

				if (this.inputElement && count > 0) {
					this.inputElement.value = count
				}

				if (this.productCount) {
					this.productCount.textContent = count
				}

				if (count === 0) {
					this.element.parentElement.removeChild(this.element)
				}
				this.eventEmitter.emit('shoppingcart-popup-product:update', json)
			})
			.catch(error => this.handleError(error))
	}
}
